
//== Advertise jobs at datamints in the developer console.
//
//##

import 'console.style';

(function() {
	if (datamintsConfig.datamintsJobs) {
		const lines = [
			'🧐 Aha, du bist wohl ein ganz ein Neugieriger! Suchst du was Frisches?',
			'🔍 Wir sind immer auf der Suche nach guten Leuten.',
			'<b="color:#009ba7">Check it out >>> https://www.datamints.com/jobs</b>',
		];
		console.style(lines.join("\n"));
	}
})();
